<template>
<b-container fluid>
<!--<button @click="DEBUG">view debug</button>-->
  <b-row>
     <b-col class="map-col">
        <TravellerMap 
          ref="map"
          @stopFeatureClicked="stopFeatureSelected"
          @deviceFeatureClicked="deviceFeatureSelected"
          @vehicleFeatureClicked="vehicleFeatureSelected"
          @closeSlideIn="closeSlideIn"
          v-bind:showSlideInClose="showSlideInClose"
          >
        </TravellerMap>
     </b-col>
     <div :style="{width: MapCardSize }">
     <b-col v-if="showActions" class="card" >
        <tabs ref="tabs" class="itemTabs">
          <tab-pane title="vehicles" key="tab-1" class="itemTabs">
            <i id="vehicles-icon" slot="title" class="nc-icon nc-bus-front-12" style="font-size: 20px"></i>
            <b-popover target="vehicles-icon" triggers="hover" placement="top">
              {{$t("map.tooltip.vehicles")}}
            </b-popover>
            <Vehicles ref="vehicles" 
              @itemSelected="vehicleFromListSelected" 
              @filterUpdated="vehicleFilterUpdated" 
              @detailClosed="vehicleDetailsClosed" 
              @vehiclesRoute="onVehiclesRoute"
              @routeLines="onRouteLines"
              @vehicleHistoryLoaded="vehicleHistoryLoaded"
              ></Vehicles>
          </tab-pane>
          <tab-pane title="stops" key="tab-2">
            <b-icon id="stops-icon" slot="title" icon="flag" scale='1.1'></b-icon>
            <b-popover target="stops-icon" triggers="hover" placement="top">
              {{$t("map.tooltip.stops")}}
            </b-popover>
            <Stops ref="stops" @itemSelected="stopFromListSelected" @filterUpdated="stopFilterUpdated" @detailClosed="clearSelectionOnMap"></Stops>
          </tab-pane>
          <tab-pane title="routes" key="tab-3">
            <b-icon id="routes-icon" slot="title" icon="bezier-2" scale='1.1'></b-icon>
            <b-popover target="routes-icon" triggers="hover" placement="top">
              {{$t("map.tooltip.routes")}}
            </b-popover>
            <Routes ref="routes" @routeSelected="routeFromListSelected" @detailsClosed="routeDetailsClosed"></Routes>
          </tab-pane>
          <tab-pane title="devices" key="tab-4">
            <b-icon id="displays-icon" slot="title" icon="display" scale='1.1'></b-icon>
            <b-popover target="displays-icon" triggers="hover" placement="top">
              {{$t("map.tooltip.displays")}}
            </b-popover>
            <Devices ref="devices" @itemSelected="deviceFromListSelected" @filterUpdated="deviceFilterUpdated" @detailClosed="clearSelectionOnMap"></Devices>
          </tab-pane>
          </tabs>
     </b-col>
    </div>
  </b-row>
 </b-container>

</template>

<script>
import TravellerMap from '@/components/Map/TravellerMap'
import Vehicles from '@/components/Map/Vehicles'
import Stops from '@/components/Map/Stops'
import Routes from '@/components/Map/Routes'
import Devices from '@/components/Map/Devices'

export default {
  name: 'MapView',
  components: {
    TravellerMap,
    Vehicles,
    Stops,
    Routes,
    Devices
  },
  data() {
    return {
      showActions: true,
      showSlideInClose: false
    }
  },
  computed: {
    cols(){
      return this.showActions ? 10 : 12;
    },
    MapCardSize() {
      return this.$UiConfig('/ui/map/mapCardSize', "450px")
    }
  },
  mounted: function(){
    if(this.$route.query.displayId) {
      this.$refs.tabs.findAndActivateTab("devices");
    }
  },
  methods: {
    onClose() {
      this.showActions = false;
    },
    stopFromListSelected(item) {
      this.$refs.map.hideRoutesOnMap();
      this.showSlideInCloser();
      try {
        this.$refs.map.panToPosition(item.spatialData.geometry.coordinates);
        this.$refs.map.showSelectionOverlay(item.spatialData.geometry.coordinates);
      } catch(err) {/*do nothing*/}
    },
    stopFilterUpdated() {
      this.$refs.map.refreshMapData('stop');
    },
    deviceFromListSelected(item) {
      this.$refs.map.hideRoutesOnMap();
      this.showSlideInCloser();
      try {
        this.$refs.map.panToPosition(item.spatialData.geometry.coordinates);
        this.$refs.map.showSelectionOverlay(item.spatialData.geometry.coordinates);
      } catch(err) {/*do nothing*/}
    },
    deviceFilterUpdated() {
      this.$refs.map.refreshMapData('device');
    },
    routeFromListSelected(item) {
      this.showSlideInCloser();
      this.$refs.map.showRouteOnMap(item.tunnus);
    },
    routeDetailsClosed() {
      this.$refs.map.hideRoutesOnMap();
      this.showSlideInClose = true;
    },
    vehicleFromListSelected(item) {
      this.$refs.map.hideRoutesOnMap();
      this.showSlideInCloser();
      try {
        this.$refs.map.hideOtherVehicles(item.vehicleLabel)
        this.$refs.map.panToPosition(item.spatialData.geometry.coordinates);
        this.$refs.map.showSelectionOverlay(item.spatialData.geometry.coordinates, item);
      } catch(err) {/*do nothing*/}
    },
    onVehiclesRoute(routeId) { 
      this.$refs.map.showRouteOnMap(routeId);
    },
    onRouteLines(routeId) {
      this.$refs.map.showLineRoutesOnMap(routeId);
    },
    vehicleDetailsClosed() {
      this.clearSelectionOnMap();
      this.$refs.map.hideRoutesOnMap();
    },
    vehicleFeatureSelected(tunnus) {
      this.$refs.map.hideRoutesOnMap();
      this.$refs.tabs.findAndActivateTab("vehicles");
      this.$refs.vehicles.showItemDetails(tunnus);
      this.showSlideInCloser();
    },
    vehicleFilterUpdated() {
      this.$refs.map.vehicleFilterUpdated();
    },
    stopFeatureSelected(tunnus) {
      this.$refs.map.hideRoutesOnMap();
      this.$refs.tabs.findAndActivateTab("stops");
      this.$refs.stops.showItemDetails(tunnus);
      this.showSlideInCloser();
    },
    deviceFeatureSelected(tunnus) {
      this.$refs.map.hideRoutesOnMap();
      this.$refs.tabs.findAndActivateTab("devices");
      this.$refs.devices.showItemDetails(tunnus);
      this.showSlideInCloser();
    },
    clearSelectionOnMap() {
      this.$refs.map.hideRoutesOnMap();
      this.$refs.map.hideSelectionOverlay();
    },
    closeSlideIn(){
      this.$refs.vehicles.item = null;
      this.$refs.stops.item = null;
      this.$refs.routes.item = null;
      this.$refs.devices.item = null;
      this.$refs.map.hideSelectionOverlay();
      this.showSlideInClose = false;
    },
    showSlideInCloser() {
      setTimeout(() => { this.showSlideInClose = true; }, 400);
    },
    vehicleHistoryLoaded(selectedDate) { 
      this.$refs.map.activateVehicleHistory(selectedDate);
    },
    DEBUG() {
      //debugger;
    }
  }
}
</script>

<style scoped lang="scss">


.itemTabs {
  max-height: 90vh;
}

.card {
  max-height: 100vh;
  overflow : hidden;
}

</style>